export function LogbookSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/logbook.svg'"></ng-include>`
    }
}